/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { formatCFA, sanitizeLinePoints } from '@/lib/utils'
import type { XYPoint } from '@/types/backend'
import { ResponsiveLine } from '@nivo/line'
import type React from 'react'

type BilanRecevablesType = {
  gridOpacity: number
  gridColor: string
  emptyMsg?: string
  receivablesMonthly: XYPoint[]
}

const ChartEmpty = ({ msg }: { msg: string }) => (
  <div className='h-full flex items-center justify-center text-sm text-muted-foreground'>
    {msg}
  </div>
)

const BilanRecevables: React.FC<BilanRecevablesType> = ({
  gridColor,
  gridOpacity,
  receivablesMonthly,
  emptyMsg = "Aucune donnée de recevables pour l'année sélectionnée.",
}) => {
  const points = sanitizeLinePoints(receivablesMonthly as any)

  return (
    <Card className='min-h-[360px]'>
      <CardHeader>
        <h4 className='text-lg font-medium'>Recevables — Fin de mois</h4>
      </CardHeader>
      <CardContent className='h-[300px]'>
        {points.length ? (
          <ResponsiveLine
            data={[{ id: 'Recevables', data: points }]}
            margin={{ top: 10, right: 10, bottom: 40, left: 48 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear', min: 'auto', max: 'auto' }}
            axisBottom={{ tickPadding: 12, tickRotation: -30 }}
            axisLeft={{ tickPadding: 6 }}
            enablePoints
            useMesh
            enableGridX
            enableGridY
            gridYValues={5}
            theme={{
              grid: { line: { stroke: gridColor, strokeOpacity: gridOpacity } },
              tooltip: { container: { fontSize: 12, borderRadius: 8 } },
            }}
            colors={['#f59e0b']}
            tooltip={({ point }) => (
              <div className='rounded-md border dark:bg-primary bg-white p-2 text-xs shadow'>
                <div>
                  Mois: <b>{String(point.data.xFormatted ?? point.data.x)}</b>
                </div>
                <div>
                  Solde: <b>{formatCFA(Number(point.data.y))}</b>
                </div>
              </div>
            )}
          />
        ) : (
          <ChartEmpty msg={emptyMsg} />
        )}
      </CardContent>
    </Card>
  )
}

export default BilanRecevables
